<template>
    <div class="task-state-viewer">
        <div class="title">{{ $t('auto.taskStepViewerSTEP') }}</div>

        <div class="content-wrapper">
            <div class="btnGroup tabs">
                <SupsisButton
                    v-for="type in ['input', 'output', 'logs']"
                    :classNames="selectedTab === type ? 'btnGroupItem selected' : 'btnGroupItem '"
                    :primary="selectedTab === type"
                    :ghost="selectedTab !== type"
                    @click="() => (selectedTab = type)"
                    small
                    :key="type"
                >
                    {{ type }}
                </SupsisButton>
            </div>
            <div class="data-viewer">
                <vue-json-pretty :data="getData()" />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default Vue.extend({
    name: "TaskStepViewer",
    components: { SupsisButton, VueJsonPretty },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                blockId: "",
                blockName: "",
                input: undefined,
                output: undefined,
                logs: [],
                order: 1,
            }),
        },
    },
    data() {
        return {
            selectedTab: "input",
        };
    },
    methods: {
        getData() {
            switch (this.selectedTab) {
                case "input":
                    return this.value.input;
                case "output":
                    return this.value.output;
                case "logs":
                    return this.value.logs;
                default:
                    return {};
            }
        },
    },
});
</script>

<style scoped lang="scss">
.task-state-viewer {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 50px;
    width: 100%;
    background-color: #f5f5f5;
    border: 1px solid var(--color-border-default);
    border-radius: 4px;
    margin: 5px;

    .title {
        font-size: 14px;
        font-weight: 500;
        color: var(--color-text-primary);
        background-color: #f3f3f3;
        padding: 5px;
        width: 100%;
        border-bottom: 1px solid var(--color-border-default);
        border-radius: 4px 4px 0 0;
    }

    .content-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;

        .data-viewer {
            width: 100%;
            display: flex;
            flex-direction: column;
            min-height: 100px;
        }

        .btnGroup {
            display: flex;
            border: 1px solid var(--color-border-default);
            background: var(--color-bg-neutral-default);
            width: 100%;

            .btnGrupItem {
                &.selected {
                    background: var(--color-bg-oncomponent-default);
                    box-shadow: var(--shadow-interaction-200);
                }
            }

            .supsis-button {
                border: none !important;
                border-radius: 0;
                font-size: 13px;
                height: 25px;
            }
        }
    }
}
</style>
